import { ModelBase } from '../../core/model/model-base';
import { Translation } from '../../core/model/translation';
import { RentalObjectCategory } from '../../rent/model/const/enums';
import { Subcategory } from './subcategory';

export class Category extends ModelBase {
  constructor(dataContext?: Category) {
    super();
    if (dataContext) {
      this.subcategories = dataContext.subcategories;
      this.name = dataContext.name;
      this.rentalObjectCategories = dataContext.rentalObjectCategories;
      this.rentalObjectAccessNeeded = dataContext.rentalObjectAccessNeeded;
      this.currentLanguageName = dataContext.currentLanguageName;
    } else {
      this.subcategories = [];
      this.name = [];
      this.rentalObjectCategories = [];
    }
  }

  rentalObjectAccessNeeded: boolean;
  subcategories: Subcategory[];
  currentLanguageName: string;
  name: Translation[];
  rentalObjectCategories: string[];

  toString() {
    return this.currentLanguageName;
  }
}
